import { APP_CONFIG_BUCKET, APP_DEFAULT_RESOURCES_DOMAIN, APP_REPLACE_RESOURCES_DOMAIN } from '../constants/envs';

export const replaceDomain = (urlSource: string): string => {
  if (APP_DEFAULT_RESOURCES_DOMAIN !== APP_REPLACE_RESOURCES_DOMAIN) {
    const url = new URL(urlSource);

    url.hostname = url.hostname.replace(`.${APP_DEFAULT_RESOURCES_DOMAIN}`, `.${APP_REPLACE_RESOURCES_DOMAIN}`);

    return url.href;
  }

  return urlSource;
};

export const replaceLogoDomain = (urlSource?: string): string => {
  if (urlSource) {
    try {
      const url = new URL(urlSource);

      url.hostname = APP_CONFIG_BUCKET;

      return url.href;
    } catch {
      return '';
    }
  }

  return '';
};

export const getChannelUrl = (basePath: string, name: string): string => `https://${basePath}/${name}`;
